(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9344],{

/***/ 62505:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login",
      function () {
        return __webpack_require__(24699);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45161);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22338);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22757);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83558);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34292);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(93108);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(57747);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(45966);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(49289);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82175);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7258);
/* harmony import */ var _components_auth_OAuthButtonGroup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19422);
/* harmony import */ var _components_layouts_navbar_DarkLogo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24498);
/* harmony import */ var _components_layouts_navbar_LightLogo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30309);
/* harmony import */ var _components_utils_FormikControl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49063);















var LoginPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var logo = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .useColorModeValue */ .ff)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_layouts_navbar_DarkLogo__WEBPACK_IMPORTED_MODULE_9__/* .DarkLogo */ .w, {}), /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_layouts_navbar_LightLogo__WEBPACK_IMPORTED_MODULE_10__/* .LightLogo */ ._, {}));
    //translation i18next
    var currentLocale = next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .i18n.language */ .ag.language;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "auth",
        "common",
        "validation"
    ]).t;
    var loginText = t("auth:login-to-account");
    var accountText = t("auth:account-dont-have");
    var remmemberText = t("auth:remember");
    var passwordForgot = t("auth:password-forgot");
    var passwordInvalid = t("validation:password-or-email-invalid");
    var signInWithText = t("auth:sign-with");
    var signUpText = t("auth:sign-up");
    var passwordText = t("common:password");
    var emailText = t("common:email");
    var requiredText = t("validation:required-field");
    var emailInvalidText = t("validation:email.invalid");
    var signInText = t("common:sign-in");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), errorCredentialsSignin = ref[0], setErrorCredentialsSignin = ref[1];
    var handleSignUp = function() {
        router.push("/auth/register");
        return;
    };
    var initialValues = {
        email: "",
        password: ""
    };
    var validationSchema = yup__WEBPACK_IMPORTED_MODULE_7__.object({
        email: yup__WEBPACK_IMPORTED_MODULE_7__.string().email(emailInvalidText).required(requiredText),
        password: yup__WEBPACK_IMPORTED_MODULE_7__.string().required(requiredText)
    });
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, props) {
            var res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("credentials", {
                            email: values.email,
                            password: values.password,
                            callbackUrl: "/migrations",
                            redirect: false
                        });
                    case 2:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : res.ok)) {
                            _ctx.next = 8;
                            break;
                        }
                        router.push("/migrations");
                        return _ctx.abrupt("return");
                    case 8:
                        {
                            setErrorCredentialsSignin(true);
                        }
                    case 9:
                        props.setSubmitting(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values, props) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Container */ .W, {
            maxW: "xl",
            py: {
                base: "12",
                md: "24"
            },
            px: {
                base: "0",
                sm: "8"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                spacing: "8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                        spacing: "6",
                        children: [
                            logo,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                                spacing: {
                                    base: "2",
                                    md: "3"
                                },
                                textAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Heading */ .X, {
                                        size: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .useBreakpointValue */ .S)({
                                            base: "xs",
                                            md: "sm"
                                        }),
                                        children: loginText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .HStack */ .U, {
                                        spacing: "1",
                                        justify: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Text */ .x, {
                                                color: "muted",
                                                children: accountText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .z, {
                                                variant: "link",
                                                colorScheme: "blue",
                                                onClick: handleSignUp,
                                                children: signUpText
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Box */ .xu, {
                        py: {
                            base: "0",
                            sm: "8"
                        },
                        px: {
                            base: "4",
                            sm: "10"
                        },
                        bg: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .useBreakpointValue */ .S)({
                            base: "transparent",
                            sm: "bg-surface"
                        }),
                        boxShadow: {
                            base: "none",
                            sm: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .useColorModeValue */ .ff)("md", "md-dark")
                        },
                        borderRadius: {
                            base: "none",
                            sm: "xl"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_22__/* .Formik */ .J9, {
                            initialValues: initialValues,
                            validationSchema: validationSchema,
                            onSubmit: onSubmit,
                            children: function(formik) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_22__/* .Form */ .l0, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                                        spacing: "6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                                                spacing: "5",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_utils_FormikControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        control: "input",
                                                        type: "email",
                                                        label: emailText,
                                                        name: "email"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_utils_FormikControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        control: "password",
                                                        label: passwordText,
                                                        name: "password"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .HStack */ .U, {
                                                justify: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__/* .Checkbox */ .X, {
                                                        defaultChecked: true,
                                                        children: remmemberText
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/auth/forgot-password/",
                                                        locale: currentLocale,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .z, {
                                                            variant: "link",
                                                            colorScheme: "blue",
                                                            size: "sm",
                                                            children: passwordForgot
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                                                spacing: "6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .z, {
                                                        mt: 4,
                                                        colorScheme: "blue",
                                                        isLoading: formik.isSubmitting,
                                                        disabled: !formik.isValid,
                                                        type: "submit",
                                                        children: signInText
                                                    }),
                                                    errorCredentialsSignin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Text */ .x, {
                                                        fontSize: "sm",
                                                        color: "red.300",
                                                        textAlign: "center",
                                                        children: passwordInvalid
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .HStack */ .U, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Divider */ .i, {}),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Text */ .x, {
                                                                fontSize: "sm",
                                                                whiteSpace: "nowrap",
                                                                color: "muted",
                                                                children: signInWithText
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Divider */ .i, {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_auth_OAuthButtonGroup__WEBPACK_IMPORTED_MODULE_8__/* .OAuthButtonGroup */ .g, {})
                                                ]
                                            })
                                        ]
                                    })
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LoginPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,4450,1664,86,8424,4444,6248,5282,3998,9774,2888,179], function() { return __webpack_exec__(62505); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);